import React from 'react';
import CardContent from '@mui/material/CardContent';
import { COLORS, Typography, FONTS } from '@fupa/fupa-uikit';
import styled from 'styled-components';
const Title = styled(Typography).withConfig({
  componentId: "sc-3vi27p-0"
})(["&&&{font-size:18px;font-weight:", ";padding-bottom:0.75rem;}"], FONTS.bold);
const Wrapper = styled.div.withConfig({
  componentId: "sc-3vi27p-1"
})(["display:flex;align-items:baseline;"]);
const StyledNewLabel = styled.div.withConfig({
  componentId: "sc-3vi27p-2"
})(["align-items:center;background-color:#0096db45;border-radius:1rem;display:inline-flex;justify-content:center;padding:0 0.5rem;position:relative;margin:0 0.5rem;& div{color:", ";font-family:", ";font-size:", ";font-weight:", ";letter-spacing:0;line-height:normal;margin-top:-1px;position:relative;text-align:center;width:fit-content;}"], COLORS.fupaSecondary, FONTS.PTSans, FONTS['12'], FONTS.bold);
const NewLabel = () => /*#__PURE__*/React.createElement(StyledNewLabel, {
  "data-sentry-element": "StyledNewLabel",
  "data-sentry-component": "NewLabel",
  "data-sentry-source-file": "OnboardingFlowCardText.tsx"
}, /*#__PURE__*/React.createElement("div", null, "NEU"));
const FlowCardText = _ref => {
  let {
    title,
    description
  } = _ref;
  return /*#__PURE__*/React.createElement(CardContent, {
    "data-sentry-element": "CardContent",
    "data-sentry-component": "FlowCardText",
    "data-sentry-source-file": "OnboardingFlowCardText.tsx"
  }, /*#__PURE__*/React.createElement(Wrapper, {
    "data-sentry-element": "Wrapper",
    "data-sentry-source-file": "OnboardingFlowCardText.tsx"
  }, /*#__PURE__*/React.createElement(Title, {
    variant: "headline",
    component: "span",
    "data-sentry-element": "Title",
    "data-sentry-source-file": "OnboardingFlowCardText.tsx"
  }, title), /*#__PURE__*/React.createElement(NewLabel, {
    "data-sentry-element": "NewLabel",
    "data-sentry-source-file": "OnboardingFlowCardText.tsx"
  })), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    "data-sentry-element": "Typography",
    "data-sentry-source-file": "OnboardingFlowCardText.tsx"
  }, description));
};
export default FlowCardText;